// extracted by mini-css-extract-plugin
module.exports = {"section":"styles_section__Fst9L","items":"styles_items__gWNbH"};